import { RegistrationProtocol } from '../../../user/registrationProtocol';
import { HubApiError } from '../../../domains/valueObject/SwitchUserProgressResponses';
import { getUrlToLoginViaToken } from '../../../login/getUrlToLoginViaToken';
import { addLoginQueryParams } from '../../../utils/url';
import { GtmSender } from '../../../marketing/GtmSender';
import { SystemEvents } from '../../../constants/gameEvents';
import { JRpcResponse } from '../jsonRpc/jsonRpcResponseFactory';
import { RegistrationResponse } from '@scorewarrior/rubens_web_lib/src/hub-api/protocol/registration-req';
import axios from 'axios';
import { getMarketingData } from '../marketing/marketing';
import { Environment } from '../../../environment/environment';
import { getErrorMessage, RegistrationErrorCode } from './getErrorMessage';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';


export async function registrationV4(regData: RegistrationProtocol): Promise<JRpcResponse<RegistrationResponse>> {
    try {
        const marketingResponse = await getMarketingData();

        const hubApi = getHubApi();

        let hubResponse: RegistrationResponse | HubApiError;
        switch (Number(regData.lp)) {
            case 4:
                hubResponse = await hubApi.registrationWithConfirmation(
                    window.app.deviceIdentifier,
                    regData.email,
                    regData.email_confirm,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse
                );
                break;
            case 2:
                hubResponse = await hubApi.registrationEmailOnly(
                    window.app.deviceIdentifier,
                    regData.email,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse
                );
                break;
            case 1:
            case 3:
            default:
                hubResponse = await hubApi.registrationWithPassword(
                    window.app.deviceIdentifier,
                    regData.email,
                    regData.password,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse
                );
        }

        let url = getUrlToLoginViaToken(hubResponse.token, hubResponse.suid);
        url = addLoginQueryParams(url);
        await axios.get(url);

        GtmSender.fireClient(SystemEvents.EMAIL_REG_SUCCESS);
        if (Environment.isLanding()) {
            GtmSender.fireClient(SystemEvents.IS_LANDING_REG);
        }

        window.app.user_huid = hubResponse.huid;

        return {
            jsonrpc: '2.0',
            result: hubResponse
        };
    } catch (exception) {
        if (![RegistrationErrorCode.EMAIL_NOT_ALLOWED, RegistrationErrorCode.WRONG_OTP].includes(exception.code)) {
            console.error(exception);
            window.Sentry.captureException(exception);
        }

        if (exception.name === 'RpcReceivedError') {
            return {
                jsonrpc: '2.0',
                error: {
                    code: exception.code,
                    message: getErrorMessage(exception.code, exception.data),
                    data: exception.data
                }
            };
        }

        return {
            jsonrpc: '2.0',
            error: {
                code: exception.code ?? 500,
                message: exception.message,
                data: {}
            }
        };
    }
}

